<template>
  <div id="entrar">
    <Loading :class="{ ocultar: state.loading }" />
    <SectionRegistrar />
  </div>
</template>

<script setup>
import { onMounted, reactive } from 'vue'
import { helperToken } from '@helpers'
import SectionRegistrar from '@components/autenticacao/registrar/partials/SectionRegistrar.vue'
import Loading from '@components/global/loading/Loading.vue'

function bloquearRotaSeLogado() {
  if (!helperToken.detectarTokenOk()) return
  window.location.assign('/inicio')
}

const state = reactive({
  loading: false
})

onMounted(() => {
  bloquearRotaSeLogado()
  setTimeout(() => {
    state.loading = true
  }, 2000)
})
</script>
